import PaymentBraintree from 'hb-react/frontoffice/components/payments/PaymentBraintree';
import { usePaymentContext } from 'hb-react/shared/components/Payment/context/PaymentContext';

export const Braintree = () => {
  const {
    paymentEndpoint,
    paymentData,
    amount,
    currency,
    onSuccess,
    hasRecurringItems,
    paymentAccountConfig,
  } = usePaymentContext();

  return (
    <PaymentBraintree
      getClientTokenUrl={Routes.braintree_to_charge_path(
        paymentAccountConfig.legacy_to_charge_object,
      )}
      executePaymentUrl={paymentEndpoint}
      additionalData={(billing) => ({
        ...paymentData,
        billing,
      })}
      amount={amount}
      currency={currency}
      paymentIsRecurring={hasRecurringItems}
      successCallback={({ data }) => onSuccess(data)}
    />
  );
};
